/**
 * Signature divider — a gentle, dynamic wave with a thin orange trim.
 *
 * Reference look: the section color above extends down with a soft wavy edge,
 * a THIN orange band rides along that wave, then the next section color begins.
 * The wave goes wide→thin across the width; use `flip` to mirror the direction
 * so it alternates between sections. It is NOT a straight line, NOT a thick
 * block, NOT a template sea-wave.
 *
 * Two modes:
 *  - normal (pass `from`): from-color fills the top with a wavy bottom edge,
 *    thin orange band on the wave, `to` below.
 *  - hero-flush (omit `from`): orange band is flush to the very top (y=0) so it
 *    attaches directly to the hero photo with NO gap; `to` fills below.
 *
 * Props: from, to (bg + section below), flip, accent (orange)
 */
export const SectionDivider = ({
  from,
  to = "#ffffff",
  flip = false,
  accent = "#f97316",
}) => {
  const heroFlush = !from;

  return (
    <div
      aria-hidden="true"
      className="relative w-full leading-[0] -mt-px pointer-events-none select-none"
      style={{ backgroundColor: to }}
    >
      <svg
        viewBox="0 0 1440 70"
        preserveAspectRatio="none"
        className={`block w-full h-[34px] sm:h-[52px] md:h-[64px] ${
          flip ? "-scale-x-100" : ""
        }`}
      >
        {!heroFlush && (
          <path
            d="M0,0 H1440 V34 C1130,50 840,16 540,30 C350,39 170,26 0,40 Z"
            fill={from}
          />
        )}
        <path
          d={
            heroFlush
              ? "M0,0 H1440 V22 C1130,34 840,10 540,20 C350,26 170,16 0,26 Z"
              : "M0,40 C170,26 350,39 540,30 C840,16 1130,50 1440,34 L1440,46 C1130,62 840,28 540,42 C350,51 170,38 0,52 Z"
          }
          fill={accent}
        />
      </svg>
    </div>
  );
};

export default SectionDivider;
